export const TYPE_DAY = 'day'
export const TYPE_WEEK = 'week'
export const TYPE_MONTH = 'month'

export const CALENDAR_EVENTS_OPTIONS = (ownerType, colors) => {
  if (!ownerType) {
    return {
      color: colors.gray3,
      backgroundColor: colors.gray7,
      icon: 'fileWithCheck',
      iconFill: 'transparent',
      iconStroke: colors.white,
      iconBackgroundColor: colors.gray3
    }
  }
  const config =
        {
          Inspection: {
            color: colors.green1,
            backgroundColor: colors.green4,
            icon: 'key',
            iconBackgroundColor: colors.green3
          },
          Deal: {
            color: colors.blue1,
            backgroundColor: colors.blue4,
            icon: 'case',
            iconBackgroundColor: colors.blue2
          },
          Revision: {
            color: colors.orange1,
            backgroundColor: colors.orange4,
            icon: 'people',
            iconBackgroundColor: colors.orange1
          },
          Claim: {
            color: colors.pink1,
            backgroundColor: colors.pink4,
            icon: 'bag',
            iconBackgroundColor: colors.pink2
          },
          Job: {
            color: colors.purple1,
            backgroundColor: colors.purple4,
            icon: 'staff',
            iconBackgroundColor: colors.purple1
          },
          Remark: {
            color: colors.red1,
            backgroundColor: colors.red4,
            icon: 'file',
            iconBackgroundColor: colors.red1
          },
          WorkRegister: {
            color: colors.purple2,
            backgroundColor: colors.purple4,
            icon: 'document',
            iconBackgroundColor: colors.purple2
          }
        }

  return config[ownerType]
}

export const TASK_STATUS_IDS = {
  NEW: 1,
  CANCELED: 5,
  DONE: 10,
  OVERDUE: -1
}

export const getEventBadge = (status, isOverdue, colors) => {
  const id = status?.id
  if (!id) return
  if (isOverdue) {
    return {
      id: TASK_STATUS_IDS.OVERDUE,
      bg_color: colors.red2,
      name: 'Просрочено'
    }
  }
  switch (id) {
    case TASK_STATUS_IDS.NEW:
      return {
        ...status,
        bg_color: colors.blue4,
        text_color: colors.gray2
      }
    case TASK_STATUS_IDS.CANCELED:
      return {
        ...status,
        bg_color: colors.gray4
      }
    case TASK_STATUS_IDS.DONE:
    default:
      return {
        ...status,
        bg_color: colors.gray4
      }
  }
}
